var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"workspace",staticClass:"workspace"},[_c('workspace-area',{on:{"openTemplateGroupManager":function($event){return _vm.$emit('openTemplateGroupManager')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }